import { createRouter, createWebHistory } from 'vue-router';
import EventCalendarPage from "./EventCalendarPage.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: []
});

bootVue('.vue-events-calendar', EventCalendarPage, {
  jsonProps: ['times', 'industries', 'types'],
  beforeMount: (el, props) => {},
  createAppWrapper: (wrapped, props) => {
    const app = createApp(wrapped, props);
    app.use(router);
    return app;
  }
});
